export class TransitAdminDto {
    RequestId: string;
    AdminEmail: string;
    Decision: number;
    TransitDate: Date;
    IsAgentPayedTotal: boolean;
    IsAgentPayedFirst: boolean;
    IsFirstConfirmedPayment: boolean;
    IsTotalConfirmedPayment: boolean;
    HasMeasureExtraFee: boolean;
    MeasureExtraFee: string;
    ChequeNumber: string;
    IsPendingDocument: boolean;
    DocuemntName: string;
    ArrivalDateTime: Date;
    Requirements: string;
    IsArrived: boolean;
    MeasurementDescription :string;
    Direction: number;
}
export class TransitAccurateDataDto {
    RequestId: string
    Accurate_DFWD: string
    Accurate_DAFT: string;
    Accurate_AirDraught: string
    Accurate_Anchor: string;
    Accurate_Cranes: string;
    Accurate_Extensions: string;
    Accurate_FloatingUnits: string;
    Accurate_MaxSpeed: string;
    Accurate_MinSpeed: string;
    Accurate_RegisterCertificateExpireDate: Date;
    Accurate_Securitylevel: string
    Accurate_PropellerTypes: string;
    Accurate_Note:string
}


export class ConfirmVesselTransit{
  ID:string;
  decision: number;
  Note:string;
  Date:string;
}
